// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App'
import Vuex from 'vuex'
import {createRouter} from './router'

import 'chart.js'
import store from './store'
import Vuetify from 'vuetify'
import VueShortKey from 'vue-shortkey'
import 'babel-polyfill'
import 'vuetify/dist/vuetify.min.css'
import VueCurrencyFilter from 'vue-currency-filter'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import VDateRange from 'vuetify-daterange-picker'
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css'
import 'vue-datetime/dist/vue-datetime.css'
import Datetime from 'vue-datetime'
import {di} from './application'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

const router = createRouter(store)

// hack for late init
di.store = store
di.router = router

Vue.config.productionTip = true
Vue.use(Vuex)
Vue.use(Vuetify)
Vue.use(VueShortKey)
Vue.use(Datetime)
Vue.use(VueCurrencyFilter, {
  symbol: '₽',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true
})
Vue.use(VDateRange)

const options = {
  toast: {
    position: SnotifyPosition.rightTop
  }
}

Vue.use(Snotify, options)

sync(store, router)

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})

store.$app = app



// WEBPACK FOOTER //
// ./src/main.js